export const taskStatus = [
    { label : 'Pending'  , value : 'Pending'},
    { label : 'Completed'  , value : 'Completed'},
    { label : 'Delayed Completion'  , value : 'DelayedCompletion'},
    { label : 'Partially Completed'  , value : 'PartiallyCompleted'},
    { label : 'Not Applicable'  , value : 'NA'},
    { label : 'Done'  , value : 'Done'},
    { label : 'Cancelled'  , value : 'Cancelled'}
] 